import React, { Component, useState, useEffect  } from 'react'; //imrc Enter

import SafeDisplayText from './displaytexthtml';

import { useContext } from 'react';
import { ShopContext } from './shopinfo';
import { useShop } from './shopinfo';


const LandingPage = () => {
 
    const { shopData, loading, pgid } = useShop();
   
 

    //console.log("🔍 useShop() returned shopData:", shopData);

    //console.log("Current shop data:", shopData); // Debugging

    if (!pgid) {
        return <div>Loading PGID...</div>;  
    }
    
    if (!shopData) {
        return <div>Loading shop data...</div>;  
    }
    
    return (
           <div>
                        {shopData ? (
                            <div className="landingPageText">
                                    <br />
                                    <h4><SafeDisplayText html={shopData.startseite_header} /></h4>
                                    <br />
                                    <SafeDisplayText html={shopData.startseite_text} />
                                
                            </div>  // ✅ Display shopData when ready
                        ) : (
                            <div>Loading shop data for {pgid || "..."}</div>  // ✅ Avoid empty page
                        )}
            </div>


    );
};

export default LandingPage;





